import { MedicalServiceEtlFields } from './MedicalServiceEtlFields';

export const MedicalServiceEtlFieldsOlos = () => {
  return <MedicalServiceEtlFields contextType="OLOS" />;
};

export default MedicalServiceEtlFieldsOlos;
